// src/components/ProductDropdown.jsx
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

/**
 * Props:
 *  - userId: number
 *  - onSelect: (product|null) => void
 *  - refreshFlag: any
 *  - value?: { sku, title } | null  (opcional, controlado)
 */
const ProductDropdown = ({ userId, onSelect, refreshFlag, value = null }) => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const baseUrl = process.env.REACT_APP_API_URL || ''

  useEffect(() => {
    if (!userId) return
    setLoading(true)
    axios.get(`${baseUrl}/api/products`, { params: { user_id: userId } })
      .then(res => {
        const sorted = res.data.products.slice().sort((a, b) => {
          const ca = (a.categories[0] || '').toLowerCase()
          const cb = (b.categories[0] || '').toLowerCase()
          if (ca < cb) return -1
          if (ca > cb) return  1
          return a.title.localeCompare(b.title)
        })
        setOptions(sorted)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [userId, refreshFlag])

  // Mapear valor controlado a un objeto opción (si existe)
  const valueObj = value
    ? options.find(o => o.sku === value.sku) || null
    : null

  return (
    <Autocomplete
      options={options}
      groupBy={opt => (opt.categories && opt.categories[0]) || 'Otros'}
      getOptionLabel={opt => `${opt.title} (${opt.sku})`}
      onChange={(_, val) => onSelect(val || null)}
      value={valueObj}
      loading={loading}
      popupIcon={<ArrowDropDownIcon />}
      renderInput={params => {
        const showClear = Boolean(valueObj)
        return (
          <TextField
            {...params}
            label="Selecciona un producto"
            placeholder="Busca por nombre o sku"
            size="small"
            fullWidth
            InputProps={{
              ...params.InputProps,
              startAdornment: showClear ? (
                <IconButton
                  size="small"
                  onClick={() => onSelect(null)}
                  sx={{ mr: 1 }}
                  title="Limpiar"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ) : null,
              endAdornment: params.InputProps.endAdornment
            }}
          />
        )
      }}
      sx={{ width: '100%' }}
    />
  )
}

export default ProductDropdown
